exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".less_button-module__mg-button___n3n8r {\n  border-radius: 2px;\n  text-decoration: none;\n}\n.less_button-module__mg-button___n3n8r span {\n  padding: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"mg-button": "less_button-module__mg-button___n3n8r"
};